module.exports = __webpack_public_path__ + "static/media/pin.6f46e3ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/maps/pin.svg
// module id = 960
// module chunks = 0